// extracted by mini-css-extract-plugin
export default {"root":"BurgerButton_root__S0Wp8"};